import React from 'react'
import { Navigate } from 'react-router-dom'
import { Documente } from '../../containers/MainPage/views'
import DocumenteRoutes from '../../containers/MainPage/routes/DocumentRoutes'
export const guest = [
  { path: 'documente', element: <Documente /> },
  { path: 'documente/*', element: <DocumenteRoutes /> },
  { path: '*', element: <Navigate to="/documente" /> }
]
